"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
const MoreVert_1 = __importDefault(require("@material-ui/icons/MoreVert"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const PopOverMenu_1 = __importDefault(require("../shared/PopOverMenu"));
const blockUser_1 = require("../../actions/chats/blockUser");
const markMessagesAsRead_1 = require("../../actions/chats/markMessagesAsRead");
const toggleNotifications_1 = require("../../actions/chats/toggleNotifications");
exports.default = react_1.default.memo(DirectChatMenu);
const useStyles = makeStyles_1.default((theme) => ({
    menuIcon: {
        color: colorManipulator_1.alpha(theme.colors.header.primaryTextColor, 0.6)
    }
}));
function DirectChatMenu(props) {
    const dispatch = react_redux_1.useDispatch();
    const unblock = react_redux_1.useSelector((state) => state.chatsState.blockedUsers).includes(props.userId);
    const classes = useStyles();
    const menuItems = [];
    // menuItems.push({ text: "Contact info", action: () => {} });
    menuItems.push({ text: props.muted ? "Unmute notifications" : "Mute notifications", action: () => dispatch(toggleNotifications_1.toggleNotifications(props.chatId, !props.muted)) });
    // menuItems.push({ text: "Delete chat", action: () => {} });
    menuItems.push({ text: unblock ? "Unblock user" : "Block user", action: () => dispatch(blockUser_1.blockUser(props.userId, unblock)) });
    menuItems.push({ text: "Mark all as read", action: () => dispatch(markMessagesAsRead_1.markAllMessagesAsReadLocally(props.chatId)), disable: !props.any_unread });
    return react_1.default.createElement(PopOverMenu_1.default, { icon: react_1.default.createElement(MoreVert_1.default, { className: classes.menuIcon }), menuItems: menuItems, placement: "bottom-end" });
}
